module.exports = __webpack_public_path__ + "img/INPRG_RED.63ad0b13.svg";